import { Formik } from 'formik'
import { Grid } from '@mui/material'

import { ProfileForm } from './profile-form'
import { SettingsSecurity } from './settings-security'
import { SettingsGeneral } from './settings-general.component'
import { DeleteButton } from './delete-button.component'
import { useEditUserProfile, useMe } from 'src/hooks'

import { userProfileSchema } from 'src/common/validations'
import { generateFormState } from './form/state.form'
import { useStyles } from './styles'
import { Loader } from '../loader'
import { isUserHaveOnlyScannerRoleForAccounts } from 'src/common/utils'

const UserProfile = () => {
  const { data: user } = useMe()
  const { mutateAsync: editUserProfile, isLoading } = useEditUserProfile()
  const classes = useStyles()

  if (!user) {
    return <Loader />
  }
  const activeWallet = user.wallets.find((wallet) => wallet.active)

  const initialValues = generateFormState(user)

  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={userProfileSchema}
        validateOnBlur={false}
        onSubmit={async (values) => {
          await editUserProfile({
            ...values,
            oldIcon: user.image,
          })
        }}
      >
        <ProfileForm isLoading={isLoading} />
      </Formik>
      <Grid className={`${classes.formWrapper} ${classes.settingsWrapper}`} container>
        <div className={classes.settingsItemsWrapper}>
          <SettingsSecurity wallet={activeWallet} />
          <SettingsGeneral isScanner={isUserHaveOnlyScannerRoleForAccounts(user.accounts)} />
        </div>
        <DeleteButton />
      </Grid>
    </>
  )
}

export { UserProfile }
